import JSData from 'js-data';
import { ODataBaseAdapter } from '@bingads-webui/js-data-odata-base-adapter';
import type { IPreference, IPreferenceDataStore } from './types';

const dataStore = new JSData.DS({ cacheResponse: false });

dataStore.registerAdapter(
  'odata',
  new ODataBaseAdapter({}),
  { default: true }
);

const preferenceDS: IPreferenceDataStore = dataStore.defineResource<IPreference, string>({
  name: 'Preference',
  idAttribute: 'Id', // Customized on the idAttribute
});

export {
  preferenceDS,
};
